module.exports = __webpack_public_path__ + "img/img-mission-success-th.svg";